var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoucher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 31,
    viewBox: "0 0 39 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_79_73)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_79_73",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 39,
    height: 31
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 0.5H0.5V30.5H38.5V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_79_73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6334 8.16666L26.8334 10.3667L14.3667 22.8333L12.1667 20.6333L24.6334 8.16666ZM4.83335 0.833328H34.1667C36.2017 0.833328 37.8334 2.46499 37.8334 4.49999V11.8333C36.8609 11.8333 35.9283 12.2196 35.2406 12.9073C34.553 13.5949 34.1667 14.5275 34.1667 15.5C34.1667 16.4725 34.553 17.4051 35.2406 18.0927C35.9283 18.7804 36.8609 19.1667 37.8334 19.1667V26.5C37.8334 28.535 36.2017 30.1667 34.1667 30.1667H4.83335C3.86089 30.1667 2.92826 29.7804 2.24063 29.0927C1.553 28.4051 1.16669 27.4725 1.16669 26.5V19.1667C3.20169 19.1667 4.83335 17.535 4.83335 15.5C4.83335 14.5275 4.44705 13.5949 3.75941 12.9073C3.07178 12.2196 2.13915 11.8333 1.16669 11.8333V4.49999C1.16669 3.52753 1.553 2.5949 2.24063 1.90727C2.92826 1.21964 3.86089 0.833328 4.83335 0.833328ZM4.83335 4.49999V9.15666C5.94743 9.79906 6.87267 10.7235 7.51599 11.8371C8.1593 12.9506 8.498 14.214 8.498 15.5C8.498 16.786 8.1593 18.0494 7.51599 19.1629C6.87267 20.2764 5.94743 21.2009 4.83335 21.8433V26.5H34.1667V21.8433C33.0526 21.2009 32.1274 20.2764 31.4841 19.1629C30.8407 18.0494 30.502 16.786 30.502 15.5C30.502 14.214 30.8407 12.9506 31.4841 11.8371C32.1274 10.7235 33.0526 9.79906 34.1667 9.15666V4.49999H4.83335ZM14.9167 8.16666C16.4384 8.16666 17.6667 9.395 17.6667 10.9167C17.6667 12.4383 16.4384 13.6667 14.9167 13.6667C13.395 13.6667 12.1667 12.4383 12.1667 10.9167C12.1667 9.395 13.395 8.16666 14.9167 8.16666ZM24.0834 17.3333C25.605 17.3333 26.8334 18.5617 26.8334 20.0833C26.8334 21.605 25.605 22.8333 24.0834 22.8333C22.5617 22.8333 21.3334 21.605 21.3334 20.0833C21.3334 18.5617 22.5617 17.3333 24.0834 17.3333Z",
    fill: "#EBB42C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_79_73"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 30,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoucher);
export default __webpack_public_path__ + "static/media/voucher.72f17ff935baf6a2435a92fd27c76df8.svg";
export { ForwardRef as ReactComponent };